import { List, ListItemButton, ListItemIcon, ListItemText, Divider, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AppstoreOutlined, LogoutOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';

interface Props {
  handleLogout: () => void;
}

const ProfileTab = ({ handleLogout }: Props) => {
  const theme = useTheme();
  const router = useRouter();
  const primaryColor = theme.palette.primary.main;
  const errorColor = theme.palette.error.main;

  const baseItemSx = {
    borderRadius: 1.5,
    mb: 0.25,
    transition: 'all 0.2s ease'
  } as const;

  return (
    <List component="nav" sx={{ p: 0.5, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        onClick={() => router.push('/signup-wizard')}
        sx={{
          ...baseItemSx,
          '&:hover': { bgcolor: alpha(primaryColor, 0.06) }
        }}
      >
        <ListItemIcon sx={{ color: 'primary.main' }}>
          <AppstoreOutlined rev={undefined} />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="body1" fontWeight={500} color="primary.main">
              เปลี่ยนกิจการ
            </Typography>
          }
        />
      </ListItemButton>

      <Divider sx={{ my: 0.5 }} />

      <ListItemButton
        onClick={handleLogout}
        sx={{
          ...baseItemSx,
          mb: 0,
          '&:hover': {
            bgcolor: alpha(errorColor, 0.06),
            '& .MuiListItemIcon-root': { color: 'error.main' },
            '& .MuiTypography-root': { color: 'error.main' }
          }
        }}
      >
        <ListItemIcon>
          <LogoutOutlined rev={undefined} />
        </ListItemIcon>
        <ListItemText primary="ลงชื่อออก" />
      </ListItemButton>
    </List>
  );
};

export default ProfileTab;
